import React, { Component } from 'react';
import Select from 'react-select';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Label } from 'reactstrap';
import CSVIcon from '../Images/csv-ico.png';
import Checkbox from '@material-ui/core/Checkbox';
import ProjectService from '../Services/ProjectService/projectService';
import { css } from 'react-emotion';
import Radio from '@material-ui/core/Radio';
import { Redirect } from 'react-router-dom';
// First way to import
import { ClipLoader } from 'react-spinners';
import ProjectsFile from '../Resources/Example of Projects.csv';
var base64 = require('base-64');


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const scrollTable = {
    'height': '100px',
    'overflowY': 'scroll'
}

class ProjectsImportFile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            ProjectList: { pennding: false, value: [] },
            ProjectUpList: { pennding: false, value: [] },
            HeadersList: [],
            error: null,
            checkboxOptions: [],
            CompanyCode: "",
            Selected: false,
            loading: false,
            AddButton: "",
            selectedValue: '2',
            Headers: false,
            HProjectCode: false,
            HProjectName: false,
            HProjectClient: false,
            HProjectInactive: false,
            HProjectCapitalized: false,
            HProjectCategory: false,
            UploadFileName: "Choose File",
            isAutenticated: true
        };
        this.handleData = this.handleData.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
        this.onChange = this.onChange.bind(this);
    }
    handleData(e) {
        var uploadedFile = e.target.files[0];
        var name = e.target.files[0] ? e.target.files[0].name : "Choose File";
        var extFile = e.target.files[0].name.split('.').pop();

        this.setState({
            ProjectUpList: { pennding: true, value: [] },
            HeadersList: [],
            Headers: false
        });

        if (uploadedFile) {

            if (extFile.toUpperCase() !== "CSV") {
                toast.error("File has to be a .CSV!", {
                    className: {
                        opacity: 0.8
                    }
                });
                return false;
            }
            let reader = new FileReader();
            reader.onload = (progressEvent) => {
                var base64result = reader.result.split(',')[1];
                var encoded = base64.decode(base64result);
                var data = encoded.split('\n');
                var DataList = [];
                data.forEach(element => {
                    DataList.push(element.split(','));
                });
                //console.log(DataList)

                var ProjectCode = "";
                var ProjectName = "";
                var ProjectClient = "";
                var ProjectInactive = "";
                var ProjectCapitalized = "";
                var ProjectCategory = "";
                DataList[0].forEach(function (element) {

                    if (element.replace(/\s/g, "").toUpperCase() === "PROJECTCODE") {

                        ProjectCode = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "PROJECTNAME") {

                        ProjectName = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "CLIENT") {

                        ProjectClient = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "INACTIVE") {

                        ProjectInactive = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "CAPITALIZED") {

                        ProjectCapitalized = element;
                    } else if (element.replace(/\s/g, "").toUpperCase() === "CATEGORY") {

                        ProjectCategory = element;
                    }
                });

                this.setState({
                    ProjectUpList: { pennding: true, value: DataList },
                    HeadersList: DataList[0],
                    Headers: true,
                    UploadFileName: name,
                    HProjectCode: { value: ProjectCode, label: ProjectCode },
                    HProjectName: { value: ProjectName, label: ProjectName },
                    HProjectClient: { value: ProjectClient, label: ProjectClient },
                    HProjectInactive: { value: ProjectInactive, label: ProjectInactive },
                    HProjectCapitalized: { value: ProjectCapitalized, label: ProjectCapitalized },
                    HProjectCategory: { value: ProjectCategory, label: ProjectCategory }
                });
            };
            reader.readAsDataURL(uploadedFile);
        } else {
            this.setState({
                ProjectUpList: { pennding: true, value: [] },
                HeadersList: [],
                Headers: true,
                UploadFileName: "Choose File"
            });
        }
    }
    handleHProjectName = event => {
        this.setState({
            HProjectName: event
        });
    }
    handleHProjectCode = event => {
        this.setState({
            HProjectCode: event
        });
    }
    handleHProjectClient = event => {
        this.setState({
            HProjectClient: event

        });
    }
    handleHProjectInactive = event => {
        this.setState({
            HProjectInactive: event
        });
    }
    handleHProjectCapitalized = event => {
        this.setState({
            HProjectCapitalized: event
        });
    }
    handleHProjectCategory = event => {
        this.setState({
            HProjectCategory: event
        });
    }
    handleChange = event => {

        this.setState({
            selectedValue: event.target.value,
            ProjectList: { pennding: false, value: [] }
        });
    }
    UploadLocationList(e) {
        e.preventDefault();

        var ActionType = this.state.selectedValue;
        var DataList = this.state.ProjectUpList.value;
        var HeaderListist = this.state.HeadersList;
        var HeaderProjectName = this.state.HProjectName.value;
        var HeaderProjectCode = this.state.HProjectCode.value;
        var HeaderProjectClient = this.state.HProjectClient.value;
        var HeaderProjectInactive = this.state.HProjectInactive.value;
        var HeaderProjectCapitalized = this.state.HProjectCapitalized.value;
        var HeaderProjectCategory = this.state.HProjectCategory.value;
        var Result = [];

        var positionProjectName = HeaderListist.indexOf(HeaderProjectName);
        var positionProjectCode = HeaderListist.indexOf(HeaderProjectCode);
        var positionProjectClient = HeaderListist.indexOf(HeaderProjectClient);
        var positionProjectInactive = HeaderListist.indexOf(HeaderProjectInactive);
        var positionProjectCapitalized = HeaderListist.indexOf(HeaderProjectCapitalized);
        var positionProjectCategory = HeaderListist.indexOf(HeaderProjectCategory);

        if (positionProjectCode === -1) {
            toast.error("Project Code field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionProjectName === -1) {
            toast.error("Project Name field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionProjectClient === -1) {
            toast.error("Client field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (positionProjectInactive === -1) {
            toast.error("Inactive field is required!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        var Capitalized = "";
        var Category = "";
        for (var i = 1; i < (DataList.length - 1); i++) {

            if (DataList[i] !== "") {

                if (positionProjectCapitalized === -1)
                    Capitalized = "";
                else
                    Capitalized = DataList[i][positionProjectCapitalized];

                if (positionProjectCategory === -1)
                    Category = "";
                else
                    Category = DataList[i][positionProjectCategory];


                Result.push({
                    CODE: DataList[i][positionProjectCode], NAME: DataList[i][positionProjectName], CLIENT: DataList[i][positionProjectClient],
                    INACTIVE: DataList[i][positionProjectInactive], CAPITALIZED: Capitalized, CATEGORY: Category
                });
            }
        }
        if (DataList === "" || DataList === null || DataList === undefined || DataList.length === 0) {
            toast.error("You must to select a File!", {
                className: {
                    opacity: 0.8
                }
            });
        } else {
            if (this.props.CompanyCode && DataList) {

                this.setState({
                    ProjectList: { pennding: true, value: [] }
                });

                var ListResult = ProjectService.getProjectListResult(this.props.CompanyCode, Result, ActionType);

                var that = this;
                ListResult.then(function (data) {
                    if (data.statusText === "OK") {
                        that.setState({
                            ProjectList: { pennding: false, value: data.data },
                            checkboxOptions: []
                        });
                    }
                }).catch((error) => {

                    that.setState({
                        ProjectList: { pennding: false, value: [] },
                        checkboxOptions: []
                    });
                    if (error.response) {
                        if (error && error.response && error.response.data.Message === "500") {
                            toast.error("Error Data Base(Error: 500)", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NoDB") {
                            toast.error("Company Code dosen't exist!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data === "NotReseller") {
                            toast.error("This User does not have permission!", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error && error.response && error.response.data.Message === "400") {
                            toast.error("API Error for Reseller", {
                                className: {
                                    opacity: 0.8
                                }
                            });
                        } else if (error.response.status === 401) {
                            sessionStorage.setItem("user", '');
                            sessionStorage.setItem("token", '');
                            sessionStorage.setItem("rol", '');
                            sessionStorage.setItem("email", '');
                            sessionStorage.clear();
                            this.setState({ isAutenticated: false },
                                () => {
                                    this.forceUpdate();
                                })
                        }
                    } else {
                        toast.error("Code Error", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    }
                });
            }
        }
    }
    onChange(e, code) {

        const options = this.state.checkboxOptions
        let index

        if (!options.find(x => x === code)) {
            options.push(code)
        } else {
            index = options.indexOf(code)
            options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e) {

        if (e.target.checked) {
            let optionChecked = [];
            this.state.ProjectList.value.forEach(l => {
                if (l.AVAILABLE)
                    optionChecked.push(l.CODE);
            })
            this.setState({ checkboxOptions: optionChecked })
        }
        else {
            this.setState({ checkboxOptions: [] })
        }
    }
    SaveProjectList(e) {
        e.preventDefault();
        var CheckboxList = this.state.checkboxOptions;
        var email = sessionStorage.getItem('email');
        var ActionType = this.state.selectedValue;
        var result = [];
        var that = this;
        that.setState({
            loading: true,
            AddButton: "disabled"
        });
        if (CheckboxList.length === 0 || ActionType === "" || ActionType === undefined || ActionType === null) {
            toast.error("You must to select a Project and Option Rows!", {
                className: {
                    opacity: 0.8
                }
            });
            that.setState({
                loading: false,
                AddButton: ""
            });
        } else {
            CheckboxList.forEach(l => {
                var project = this.state.ProjectList.value.find(x => x.CODE === l);
                result.push(project);
            });
            var DataResult = ProjectService.SaveProject(this.props.CompanyCode, result, ActionType, email);
            DataResult.then(function (data) {
                if (data.data === "OK") {
                    that.setState({
                        loading: false,
                        ProjectList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.success("Projects Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "No") {
                    that.setState({
                        loading: false,
                        ProjectList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.statusText === "AuditError") {
                    that.setState({
                        loading: false,
                        ProjectList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("No Saved!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "NotFound") {
                    that.setState({
                        loading: false,
                        ProjectList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("User does not have permission for this Company!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                } else if (data.data === "InUse") {
                    that.setState({
                        loading: false,
                        ProjectList: { pennding: false, value: [] },
                        checkboxOptions: [],
                        AddButton: "",
                        CompanyCode: "",
                    });
                    toast.error("Project Code in Use!", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }

            }).catch((error) => {
                that.setState({
                    loading: false,
                    ProjectList: { pennding: false, value: [] },
                    checkboxOptions: [],
                    AddButton: "",
                    CompanyCode: "",
                });
                if (error.response) {
                    if (error && error.response && error.response.data.Message === "500") {
                        toast.error("Error Data Base(Error: 500)", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NoDB") {
                        toast.error("Company Code dosen't exist!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data === "NotReseller") {
                        toast.error("This User does not have permission!", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error && error.response && error.response.data.Message === "400") {
                        toast.error("API Error for Reseller", {
                            className: {
                                opacity: 0.8
                            }
                        });
                    } else if (error.response.status === 401) {
                        sessionStorage.setItem("user", '');
                        sessionStorage.setItem("token", '');
                        sessionStorage.setItem("rol", '');
                        sessionStorage.setItem("email", '');
                        sessionStorage.clear();
                        this.setState({ isAutenticated: false },
                            () => {
                                this.forceUpdate();
                            })
                    }
                } else {
                    toast.error("Code Error", {
                        className: {
                            opacity: 0.8
                        }
                    });
                }
            });
        }
    }
    changeName(e) {
        //alert(e.target.value)
        var str = e.target.value;
        var res = str.substring(12)
        var extention = res.split('.').pop();

        if (extention.toUpperCase() === "CSV") {
            this.setState({
                FileName: res
            });
        } else {
            this.setState({
                FileName: "CHOOSE A FILE",
                DepartmentUpList: { pennding: false, value: [] },
            });
            toast.error("File Error!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        return true;
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'} />)
        }

        let optionItemsHeaders = this.state.HeadersList.map((item, index) => {
            return { value: item, label: item }
        });

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body">
                        <div className="row">
                            <div className="col-2">
                                <h4><span className="badge badge-info">Projects</span></h4>
                            </div>
                            <div className="col-2 offset-10">
                                <Label for="exampleFile" style={{ 'fontWeight': 'bold' }}>Download Sample</Label>
                                <a href={ProjectsFile} download="Example of Projects.CSV"><img src={CSVIcon} title="NotImage" alt="" width='40px' /></a>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-3 offset-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div className="upload-btn-wrapper" key={Math.random() * 1200000}>
                                        <button style={{ 'width': '100%', 'backgroundColor': '#00C851', 'marginLeft': '0px' }} onClick={(e) => this.fileInput.click(e)} className="btn btn-primary">{this.state.UploadFileName}</button>
                                        <input ref={input => this.fileInput = input} type="file" name="myfile" style={{ 'display': 'none' }} onChange={(event) => { this.handleData(event) }} />
                                    </div>
                                }
                            </div>
                            <div className="col-2">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Delete Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '1'}
                                            onChange={this.handleChange}
                                            value="1"
                                            name="radio-button-demo"
                                            aria-label="A"
                                            color="primary"
                                        />
                                    </div>
                                }
                            </div>
                            <div className="col-3">
                                {
                                    this.props.CompanyCode
                                    &&
                                    <div >
                                        <label>Appends Rows in Table</label>
                                        <Radio
                                            checked={this.state.selectedValue === '2'}
                                            onChange={this.handleChange}
                                            value="2"
                                            name="radio-button-demo"
                                            aria-label="B"
                                            color="primary"
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                        <br /> <br />
                        {
                            this.state.Headers
                            &&
                            <div className="row">
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }}>Project Code(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HProjectCode}
                                            onChange={this.handleHProjectCode}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Project Name(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HProjectName}
                                            onChange={this.handleHProjectName}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Client(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HProjectClient}
                                            onChange={this.handleHProjectClient}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Inactive(<span style={{ color: 'red' }}>*</span>):</label>
                                        <Select
                                            value={this.state.HProjectInactive}
                                            onChange={this.handleHProjectInactive}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }} >Capitalized</label>
                                        <Select
                                            value={this.state.HProjectCapitalized}
                                            onChange={this.handleHProjectCapitalized}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {
                            this.state.Headers
                            &&
                            <div className="row">
                                <div className="col-2">
                                    <div className="form-group">
                                        <label style={{ 'fontWeight': '900', textAlign: "right", display: "inline-block" }}>Category</label>
                                        <Select
                                            value={this.state.HProjectCategory}
                                            onChange={this.handleHProjectCategory}
                                            options={optionItemsHeaders}
                                            styles={{ width: "10px" }}
                                        />
                                    </div>
                                </div>
                                <div className="col-2 offset-8" style={{ paddingTop: '28px' }}>
                                    <div className="form-group">
                                        <button className="btn btn-info" onClick={(e) => { this.UploadLocationList(e) }} >Preview</button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
                {
                    (this.state.ProjectList.pennding
                        && <span className="loader"></span>)
                    ||
                    (this.state.ProjectList.value.length > 0
                        && <div className="card Logs">
                            <div className="card-body">
                                <div className="row" style={{ 'height': '350px', 'overflow': 'auto' }}>
                                    <table className="table table-hover table-striped table-sm" >
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <Checkbox
                                                        style={{ width: 25, height: 25 }}
                                                        // checked={this.state.Selected}
                                                        onChange={this.SelectedAll}
                                                        //value={this.state.checkboxOptions}
                                                        color="primary"
                                                    />
                                                </th>
                                                <th scope="col">Project #</th>
                                                <th scope="col">Name</th>
                                                <th scope="col">Client</th>
                                                <th scope="col">Inactive</th>
                                                <th scope="col">Capitalized</th>
                                                <th scope="col">Category</th>
                                            </tr>
                                        </thead>
                                        <tbody style={scrollTable}>
                                            {
                                                (this.state.ProjectList.pennding
                                                    && <tr><td colSpan="7"><span className="loader"></span></td></tr>)
                                                || this.state.ProjectList.value.map((item, index) => {

                                                    return <tr key={index}>
                                                        <td>
                                                            {
                                                                (item.AVAILABLE
                                                                    &&
                                                                    <Checkbox
                                                                        style={{ width: 25, height: 25 }}
                                                                        checked={this.state.checkboxOptions.find(x => x === item.CODE) !== undefined}
                                                                        onChange={(e) => this.onChange(e, item.CODE)}
                                                                        value={item.CODE}
                                                                        color="primary"
                                                                    />)
                                                                ||
                                                                <span className="badge badge-danger">{item.AVAILABLE_MSG}</span>
                                                            }

                                                        </td>
                                                        <td>{item.CODE}</td>
                                                        <td>{item.NAME}</td>
                                                        <td>{item.CLIENT}</td>
                                                        <td>{item.INACTIVE}</td>
                                                        <td>{item.CAPITALIZED}</td>
                                                        <td>{item.CATEGORY}</td>
                                                    </tr>;
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div className="row">
                                    <div className="col-2 offset-10">
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loading}
                                        />
                                        <button disabled={this.state.AddButton} className="btn btn-info" onClick={(e) => { this.SaveProjectList(e) }} >Save</button>
                                    </div>
                                </div>
                            </div>
                        </div>)
                }
            </div>
        );
    }
}

export default ProjectsImportFile;


// WEBPACK FOOTER //
// ./src/ImportFile/ProjectsImportfile.jsx